export default __webpack_public_path__ + "static/media/Ballroll_00346.3c7b5742.png";